<div class="go-back-button" (click)="goToBackComponent()"><i class="icon"></i></div>
